// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__2eWP_","messages":"Chat_messages__4a7Y7","dateDivider":"Chat_dateDivider__AtPb5"};